class HeroMovie {
    constructor(section) {
        if (!section) return;

        this.init(section);
    }

    async init(section) {
        this.root = section;

        this.wrapper = this.root.querySelector('[js-wrapper]');

        this.poster = this.root.querySelector('[js-poster]');

        this.canvas = this.root.querySelector('canvas');

        this.ctx = this.canvas.getContext('2d');

        this.frames = JSON.parse(this.root.getAttribute('data-frames'));

        this.images = [];

        this.currentFrame = 0;

        this.targetFrame = 0;

        this.isTicking = false;

        await this.preloadImages();

        this.resizeCanvas();

        this.render(0);

        this.updateScroll();

        this.bindEvents();

        this.animate();
    }

    preloadImages() {
        return Promise.all(
            this.frames.map(src => {
                return new Promise(resolve => {
                    const img = new Image();

                    img.src = src;

                    img.onload = () => resolve(img);

                    this.images.push(img);
                });
            })
        );
    }

    bindEvents() {
        window.addEventListener('resize', this.resizeCanvas.bind(this));

        window.addEventListener('scroll', this.onScroll.bind(this));
    }

    resizeCanvas() {
        this.canvas.width = window.innerWidth;

        this.canvas.height = window.innerHeight;

        this.render(Math.round(this.currentFrame));
    }

    onScroll() {
        if (!this.isTicking) {
            requestAnimationFrame(() => {
                this.updateScroll();

                this.isTicking = false;
            });

            this.isTicking = true;
        }
    }

    updateScroll() {
        const rect = this.wrapper.getBoundingClientRect();

        const maxScroll = this.wrapper.offsetHeight - window.innerHeight;

        const scrollTop = -rect.top;

        let progress = scrollTop / maxScroll;

        progress = Math.max(0, Math.min(progress, 1));

        this.targetFrame = Math.floor(progress * (this.images.length - 1));
    }

    animate() {
        this.currentFrame += (this.targetFrame - this.currentFrame) * 0.1;

        this.render(Math.round(this.currentFrame));

        requestAnimationFrame(this.animate.bind(this));
    }

    render(frameIndex) {
        const img = this.images[frameIndex];

        if (!img) return;

        const canvasWidth = this.canvas.width;

        const canvasHeight = this.canvas.height;

        const imageWidth = img.width;

        const imageHeight = img.height;

        const scale = Math.max(
            canvasWidth / imageWidth,
            canvasHeight / imageHeight
        );

        const x = (canvasWidth - imageWidth * scale) / 2;

        const y = (canvasHeight - imageHeight * scale) / 2;

        this.ctx.clearRect(0, 0, canvasWidth, canvasHeight);

        this.ctx.drawImage(img, x, y, imageWidth * scale, imageHeight * scale);
    }
}

const sections = document.querySelectorAll('section.hero-movie');

if (sections.length) {
    sections.forEach(section => {
        new HeroMovie(section);
    });
}
